module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mt-cell', {
    staticClass: "oa-cell",
    attrs: {
      "title": _vm.option.name,
      "is-link": "",
      "to": "click"
    },
    on: {
      "cellClick": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "iconfont icon-center",
    class: _vm.iconMap[_vm.option.ext] || _vm.iconMap.default,
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d75e19c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobileDetail/attachmentCell.vue
// module id = 571
// module chunks = 0